namespace Portico.Services {
    import Inject = Portico.Decorators.Inject;
	import Service = Portico.Decorators.Service;
    import psga = apigateway.client;
    import psgm = apigateway.models;

    export interface ICaseService {
        getCaseTypeStatuses: (caseTypeId: number) => angular.IPromise<psgm.CaseTypeStatusModel[]>
    }

    @Service('app', 'caseService')
	@Inject('$q', 'CaseV3Api')
    export class CaseService implements ICaseService {
		constructor(
            private $q: angular.IQService,
            private caseApi: psga.CaseV3Api
        ){}

        getCaseTypeStatuses(caseTypeId: number) {
            return this.$q.when(this.caseApi.caseTypeStatusGetByProgramId(caseTypeId).then(response => {
                return response.data.data;
            }));
        }
    }
}